import { useMemo } from 'react';
import { useApi } from './api';

export const useTeamAppConfig = (abbrv) => {
  const [ticketConfig, loading, error] = useApi('team-app-config');

  const teamConfig = useMemo(
    () => (abbrv ? ticketConfig?.find((i) => i?.abbrv === abbrv) : null),
    [ticketConfig, abbrv]
  );

  return [teamConfig, loading, error];
};
